import * as React from 'react';
import cx from 'classnames';

import wrapStore from '@src/utils/wrap-store';
import CommonModalStore from '@src/business-components/common-modal/store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';

const styles = require('./index.less');

/**
 * 分享弹窗
 * @param {CommonModalStore} store
 * @param onClose
 * @return {JSX.Element}
 * @constructor
 */
const CommonModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.commonModalRoot)}>
        <div className={styles.content}>
          <div className={styles.award}>
            <img src={store.image} alt={''} />
          </div>
          <div className={styles.line} />
          <div className={styles.virtualReward}>
            <div className={styles.title}>{store.text}</div>

            {store.clickSubmitCallback ? (
              <Link className={cx(styles.submitText)} onClick={store.onClickSubmit}>
                请点击前往填写收货信息{'>'}{'>'} {'>'}
              </Link>
            ) : (
              <div className={styles.tips}>{store.tips}</div>
            )}
          </div>
        </div>

        <Link className={cx(styles.close)} onClick={store.onClickClose} />
      </div>
    </ModalContainer>
  );
};

export default wrapStore(CommonModal, CommonModalStore);
